import $ from 'jquery'

$('.js-accordion').on('click', event => {
  const $trigger = $(event.currentTarget)
  const id = $trigger.attr('href')
  const $target = id ? $(id) : $trigger.next()
  $target.slideToggle()

  // 閉じる時に迷子にならないように開いた地点 or 任意の場所まで戻る
  const returnSelecter = $trigger.closest('.js-accordion-return')
  const returnPos = returnSelecter.length
    ? returnSelecter.offset().top
    : $target.offset().top
  const targetOpened =
    $trigger.data('inner-btn') || $trigger.hasClass('is-opened')
  if (targetOpened && window.pageYOffset > returnPos) {
    $('html, body').animate({ scrollTop: returnPos - 50 })
  }

  $trigger.toggleClass('is-opened')

  // open / close のテキストを変更したい時
  const toggleText = $trigger.data('toggle-text')
  if (toggleText) {
    const text = $trigger.hasClass('is-opened')
      ? toggleText['close']
      : toggleText['open']
    $trigger.text(text)
  }

  return false
})
